import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2eb0dd42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-topbar d-flex align-items-center flex-shrink-0" }
const _hoisted_2 = {
  class: "header-topbar__user",
  id: "kt_header_user_menu_toggle"
}
const _hoisted_3 = {
  class: "header-topbar__user-trigger cursor-pointer",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-attach": "parent",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "bottom",
  "data-kt-menu-overflow": "true"
}
const _hoisted_4 = { class: "header-topbar__avatar" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "header-topbar__meta d-none d-md-flex" }
const _hoisted_7 = { class: "header-topbar__name" }
const _hoisted_8 = {
  key: 0,
  class: "header-topbar__year"
}
const _hoisted_9 = {
  class: "d-flex align-items-center d-lg-none ms-2 me-n3",
  title: "Show header menu"
}
const _hoisted_10 = {
  class: "btn btn-icon btn-active-light-primary btn-custom w-30px h-30px w-md-40px h-md-40px",
  id: "kt_header_menu_mobile_toggle"
}
const _hoisted_11 = { class: "svg-icon svg-icon-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTUserMenu = _resolveComponent("KTUserMenu")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: _ctx.avatarSrc,
            alt: _ctx.userDetail.fullName || 'avatar'
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.displayName), 1),
          (_ctx.workingYear)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, " Năm làm việc: " + _toDisplayString(_ctx.workingYear), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_KTUserMenu)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("span", _hoisted_11, [
          _createVNode(_component_inline_svg, { src: "media/icons/duotune/text/txt001.svg" })
        ])
      ])
    ])
  ]))
}